<span class="__invisible-anchor" [satPopoverAnchor]="popRef"></span>

<sat-popover
  #popRef
  [horizontalAlign]="horizontalAlign()"
  [verticalAlign]="verticalAlign()"
  hasBackdrop
  backdropClass="zef-pop-light-backdrop"
  (backdropClicked)="popRef.close(); closeTrigger.emit()"
  (opened)="verificationTextInput.set('')"
>
  <mat-card class="__pop z-manual-elevation c-soft-elevation">
    <div class="__header-wrapper">
      <h3 class="__title" [innerHTML]="heading()"></h3>
      @if (subtitle()) {
        <h5 class="__subtitle">{{ subtitle() }}</h5>
      }
    </div>

    <ng-content></ng-content>

    @if (enableTextConfirmation()) {
      <p class="__confirmation-text">
        To confirm deletion, write
        <zef-copy-to-clipboard
          mode="basic"
          [copyData]="confirmationText()"
          tooltip="Copy text to clipboard"
          tooltipClass="c-zerops-tooltip"
        >
          <strong>{{ confirmationText() }}</strong>
        </zef-copy-to-clipboard>
        in the field below.
      </p>
      <mat-form-field color="accent" class="__confirm-form-field">
        <input
          matInput
          type="text"
          [value]="verificationTextInput()"
          (input)="verificationTextInput.set($event.target.value)"
          placeholder="Enter confirmation text..."
          class="__text-input"
          required
        />
      </mat-form-field>
    }

    <div class="__actions-grid">
      <div>
        <button
          mat-flat-button
          [color]="confirmColor()"
          type="button"
          class="__button __primary-button"
          [disabled]="
            enableTextConfirmation() &&
            confirmationText() !== verificationTextInput()
          "
          (click)="confirm.emit(); popRef.close()"
        >
          @if (confirmButtonIcon()) {
            <mat-icon>{{ confirmButtonIcon() }}</mat-icon>
          }
          {{ confirmButtonText() }}
        </button>
      </div>

      <div>
        <button
          mat-button
          type="button"
          class="__button"
          (click)="closeTrigger.emit(); popRef.close()"
        >
          {{ closeButtonText() }}
        </button>
      </div>
    </div>
  </mat-card>
</sat-popover>
